import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import loadingAnimaton from "@/components/loadingAnimaton/loadingAnimaton.vue";
import { getLang } from '@/api/utils/apiHelper';

var MyReportButton =
/*#__PURE__*/
function (_Vue) {
  _inherits(MyReportButton, _Vue);

  function MyReportButton() {
    _classCallCheck(this, MyReportButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(MyReportButton).apply(this, arguments));
  }

  _createClass(MyReportButton, [{
    key: "clickBotton",
    value: function clickBotton() {}
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "isGerman",
    get: function get() {
      return getLang() === "de";
    }
  }]);

  return MyReportButton;
}(Vue);

tslib_1.__decorate([Prop({
  default: true
})], MyReportButton.prototype, "transparent", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], MyReportButton.prototype, "text", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], MyReportButton.prototype, "buttonHeight", void 0);

tslib_1.__decorate([Prop({
  default: false
})], MyReportButton.prototype, "small", void 0);

tslib_1.__decorate([Prop({
  default: false
})], MyReportButton.prototype, "white", void 0);

tslib_1.__decorate([Emit("clickButton")], MyReportButton.prototype, "clickBotton", null);

MyReportButton = tslib_1.__decorate([Component({
  components: {
    loadingAnimaton: loadingAnimaton
  }
})], MyReportButton);
export default MyReportButton;